import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import { fetchWithOrg } from '../utils/api';
import { useOrganization } from '../context/OrganizationContext';

/**
 * Custom hook to get current user's role in active organization
 */
export const useUserRole = () => {
  const { activeOrganization } = useOrganization();
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (activeOrganization) {
      fetchRole();
    } else {
      setRole(null);
      setLoading(false);
    }
  }, [activeOrganization]);

  const fetchRole = async () => {
    try {
      setLoading(true);
      const response = await fetchWithOrg(
        `${BACKEND_URL}/api/team/my-role`,
        {},
        activeOrganization.organization_id
      );

      if (response.ok) {
        const data = await response.json();
        setRole(data.role);
      } else {
        setRole(null);
      }
    } catch (error) {
      console.error('Error fetching user role:', error);
      setRole(null);
    } finally {
      setLoading(false);
    }
  };

  const isAdmin = role === 'admin' || role === 'primary_admin';
  const isMember = role === 'member' || role === 'admin' || role === 'primary_admin';
  const isViewer = role === 'viewer' || role === 'member' || role === 'admin' || role === 'primary_admin';

  return {
    role,
    loading,
    isAdmin,
    isMember,
    isViewer,
    refetch: fetchRole
  };
};
